import { render, staticRenderFns } from "./SelfStudyGroup.vue?vue&type=template&id=9b83e760&"
import script from "./SelfStudyGroup.vue?vue&type=script&lang=js&"
export * from "./SelfStudyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports